@if (!resetSuccessful) {
  <div class="reset-container">
    <h2>Passwort zurücksetzen</h2>
    <form [formGroup]="resetForm" (ngSubmit)="submit()">
      <mat-form-field appearance="fill">
        <mat-label>Token</mat-label>
        <input matInput formControlName="token" required>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Neues Passwort</mat-label>
        <input matInput type="password" formControlName="newPassword" required>
      </mat-form-field>
      <button mat-raised-button color="primary" type="submit" [disabled]="resetForm.invalid">
        Passwort ändern
      </button>
    </form>
    @if (resetError) {
      <div class="error-message">
        {{ resetError }}
      </div>
    }
  </div>
} @else {
  <h2>Passwort erfolgreich geändert!</h2>
  <p>Du wirst gleich zum Dashboard weitergeleitet...</p>
}

